import { Component, ElementRef, NgZone, ViewChild, ViewEncapsulation } from '@angular/core';
import { TestimonialSliderContent } from '../../core/models/mysec/for-founders-slider-logos';
import type { SwiperContainer } from 'swiper/element';

@Component({
    selector: 'app-testimonial',
    templateUrl: './testimonial.component.html',
    styleUrls: ['./testimonial.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TestimonialComponent {
  constructor(private ngZone: NgZone) {}
  selectedIndex: number = 0;

  @ViewChild('swiper', { static: false }) swiperElRef?: ElementRef<SwiperContainer>;

  setIndex(index: number) {
    this.selectedIndex = index;
  }

  isSelectedIndex(index: number) {
    return index === this.selectedIndex;
  }

  onSlideChange(event: CustomEvent<[swiper: { activeIndex: number }]>) {
    this.ngZone.run(() => {
      const [swiper] = event.detail;
      this.selectedIndex = swiper ? swiper.activeIndex : 0;
    });
  }

  onButtonClick(index: number) {
    this.ngZone.run(() => {
      this.swiperElRef.nativeElement.swiper.slideTo(index);
    });
  }

  testimonialSlider: TestimonialSliderContent[] = [
    {
      'backgroundColour': '#AB4499',
      'testimonial': 'landing.testimonialCommerceAsia',
      'authourAvatar': 'commerce-asia-founder.jpeg',
      'authourName': 'Ganesh Kumar Bangah',
      'authourRole': 'landing.roleFounderExecChairman',
      'companyName': 'Commerce.Asia',
      'caseStudyContent': ``,
      'caseStudyRedirectUrl': 'www.google.com',
      'companyLogoUrl': 'logo_rectangle_commerce_dot_asia.png',
      'backgroundImage': 'commerce-asia-banner-bg.png',
    },
    {
      'backgroundColour': '#45B0C8',
      'testimonial': 'landing.testimonialKakitangan',
      'authourAvatar': 'kakitangan-founder.jpeg',
      'authourName': 'Effon Khoo',
      'authourRole': 'landing.roleFounder',
      'companyName': 'Kakitangan',
      'caseStudyContent': ``,
      'caseStudyRedirectUrl': 'www.google.com',
      'companyLogoUrl': 'logo_rectangle_kakitangan.png',
      'backgroundImage': 'kakitangan-banner-bg.png',
    },
    {
      'backgroundColour': '#5DAC46',
      'testimonial': 'landing.testimonialSignatureMarket',
      'authourAvatar': 'signature-market-founder.jpeg',
      'authourName': 'Edwin Wang',
      'authourRole': 'landing.roleCofounderCeo',
      'companyName': 'Signature Market',
      'caseStudyContent': ``,
      'caseStudyRedirectUrl': 'www.google.com',
      'companyLogoUrl': 'logo_rectangle_signature_market.png',
      'backgroundImage': 'signature-market-banner-bg.png',
    },
    {
      'backgroundColour': '#CEA02E',
      'testimonial': 'landing.testimonialOxwhite',
      'authourAvatar': 'oxwhite-founder.jpeg',
      'authourName': 'CK Chang',
      'authourRole': 'landing.roleFounder',
      'companyName': 'OXWHITE',
      'caseStudyContent': ``,
      'caseStudyRedirectUrl': 'www.google.com',
      'companyLogoUrl': 'logo_rectangle_oxwhite.png',
      'backgroundImage': 'oxwhite-banner-bg.png',
    },
  ];
}
